import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PreviewTestDataComponent } from './preview-test-data/preview-test-data.component';

const routes: Routes = [
  {
    path: '',
    component: PreviewTestDataComponent,
    data: {
      title: 'Preview Test Data',
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PreviewTestDataRoutingModule { }
